// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.maintineFlex {
  margin-left: 8rem;
}

.maintineFlex-2 {
  margin-right: 8rem;
}

.navbarm-header-jw {
  color: white;
}

.button-m {
  color: white;
  transition: 1s;
}

.button-m:hover {
  text-decoration: underline;
  text-decoration-color: lightblue;
  text-decoration-thickness: 2px;
}

.button-m-active-au,
.button-m-active-p,
.button-m-active-c,
.button-m-active-cu {
  color: white;
  text-decoration: underline;
  text-decoration-color: lightblue;
  text-decoration-thickness: 2px;
}

nav {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  background-color: #126fdb;
}

.rotate-picture-nav-bar {
  transition: 2s;
}

.mantine-flex-2-text {
  font-family: "Sora", sans-serif;
  font-weight: 400;
}

/*Max-width is basically saying 500px, if youre in that this will happen*/
@media all {
  /* xs, extra-small: 0px
  sm, small: 600px
  md, medium: 900px
  lg, large: 1200px
  xl, extra-large: 1536px */

  @media only screen and (max-width: 768px) {
    .maintineFlex-2 {
      margin-right: 0rem;
    }

    .maintineFlex-2 a {
      margin-left: auto;
      margin-right: 3rem;
    }
  }

  @media only screen and (max-width: 600px) {
    .maintineFlex-2 a {
      margin-left: auto;
      margin-right: 1rem;
    }
  }

  @media only screen and (min-width: 300px) {
    .maintineFlex {
      margin-left: 0.5rem;
    }

    /* .maintineFlex-2 {
      margin-right: 0.5rem;
    } */
  }
  /* Extra small devices (phones, 600px and down) */
  @media only screen and (min-width: 500px) {
    .maintineFlex {
      margin-left: 1rem;
    }
  }

  /* Small devices (portrait tablets and large phones, 600px and up) */
  @media only screen and (min-width: 600px) {
    .maintineFlex {
      margin-left: 3rem;
    }
  }

  /* Medium devices (landscape tablets, 768px and up) */
  @media only screen and (min-width: 768px) {
    .maintineFlex {
      margin-left: 4rem;
    }

    .maintineFlex-2 {
      margin-right: 4rem;
    }

    .maintineFlex-2 a {
      margin-left: 0rem;
      margin-right: 0rem;
    }
  }
  /* Large devices (laptops/desktops, 992px and up) */
  @media only screen and (min-width: 992px) {
    .maintineFlex {
      margin-left: 6rem;
    }

    .maintineFlex-2 {
      margin-right: 6rem;
    }
  }
  /* Extra large devices (large laptops and desktops, 1200px and up) */
  @media only screen and (min-width: 1200px) {
    .maintineFlex {
      margin-left: 8rem;
    }

    .maintineFlex-2 {
      margin-right: 8rem;
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/Navbar-Maintine/Navbarm.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;;;;EAIE,YAAY;EACZ,0BAA0B;EAC1B,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA,yEAAyE;AACzE;EACE;;;;2BAIyB;;EAEzB;IACE;MACE,kBAAkB;IACpB;;IAEA;MACE,iBAAiB;MACjB,kBAAkB;IACpB;EACF;;EAEA;IACE;MACE,iBAAiB;MACjB,kBAAkB;IACpB;EACF;;EAEA;IACE;MACE,mBAAmB;IACrB;;IAEA;;OAEG;EACL;EACA,iDAAiD;EACjD;IACE;MACE,iBAAiB;IACnB;EACF;;EAEA,oEAAoE;EACpE;IACE;MACE,iBAAiB;IACnB;EACF;;EAEA,qDAAqD;EACrD;IACE;MACE,iBAAiB;IACnB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,iBAAiB;MACjB,kBAAkB;IACpB;EACF;EACA,mDAAmD;EACnD;IACE;MACE,iBAAiB;IACnB;;IAEA;MACE,kBAAkB;IACpB;EACF;EACA,oEAAoE;EACpE;IACE;MACE,iBAAiB;IACnB;;IAEA;MACE,kBAAkB;IACpB;EACF;AACF","sourcesContent":[".maintineFlex {\n  margin-left: 8rem;\n}\n\n.maintineFlex-2 {\n  margin-right: 8rem;\n}\n\n.navbarm-header-jw {\n  color: white;\n}\n\n.button-m {\n  color: white;\n  transition: 1s;\n}\n\n.button-m:hover {\n  text-decoration: underline;\n  text-decoration-color: lightblue;\n  text-decoration-thickness: 2px;\n}\n\n.button-m-active-au,\n.button-m-active-p,\n.button-m-active-c,\n.button-m-active-cu {\n  color: white;\n  text-decoration: underline;\n  text-decoration-color: lightblue;\n  text-decoration-thickness: 2px;\n}\n\nnav {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  background-color: #126fdb;\n}\n\n.rotate-picture-nav-bar {\n  transition: 2s;\n}\n\n.mantine-flex-2-text {\n  font-family: \"Sora\", sans-serif;\n  font-weight: 400;\n}\n\n/*Max-width is basically saying 500px, if youre in that this will happen*/\n@media all {\n  /* xs, extra-small: 0px\n  sm, small: 600px\n  md, medium: 900px\n  lg, large: 1200px\n  xl, extra-large: 1536px */\n\n  @media only screen and (max-width: 768px) {\n    .maintineFlex-2 {\n      margin-right: 0rem;\n    }\n\n    .maintineFlex-2 a {\n      margin-left: auto;\n      margin-right: 3rem;\n    }\n  }\n\n  @media only screen and (max-width: 600px) {\n    .maintineFlex-2 a {\n      margin-left: auto;\n      margin-right: 1rem;\n    }\n  }\n\n  @media only screen and (min-width: 300px) {\n    .maintineFlex {\n      margin-left: 0.5rem;\n    }\n\n    /* .maintineFlex-2 {\n      margin-right: 0.5rem;\n    } */\n  }\n  /* Extra small devices (phones, 600px and down) */\n  @media only screen and (min-width: 500px) {\n    .maintineFlex {\n      margin-left: 1rem;\n    }\n  }\n\n  /* Small devices (portrait tablets and large phones, 600px and up) */\n  @media only screen and (min-width: 600px) {\n    .maintineFlex {\n      margin-left: 3rem;\n    }\n  }\n\n  /* Medium devices (landscape tablets, 768px and up) */\n  @media only screen and (min-width: 768px) {\n    .maintineFlex {\n      margin-left: 4rem;\n    }\n\n    .maintineFlex-2 {\n      margin-right: 4rem;\n    }\n\n    .maintineFlex-2 a {\n      margin-left: 0rem;\n      margin-right: 0rem;\n    }\n  }\n  /* Large devices (laptops/desktops, 992px and up) */\n  @media only screen and (min-width: 992px) {\n    .maintineFlex {\n      margin-left: 6rem;\n    }\n\n    .maintineFlex-2 {\n      margin-right: 6rem;\n    }\n  }\n  /* Extra large devices (large laptops and desktops, 1200px and up) */\n  @media only screen and (min-width: 1200px) {\n    .maintineFlex {\n      margin-left: 8rem;\n    }\n\n    .maintineFlex-2 {\n      margin-right: 8rem;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
